var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 62,
    fill: "#757868",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.7539 77.2996C23.7539 66.4818 23.7539 61.0729 27.1146 57.7122C30.4752 54.3516 35.8841 54.3516 46.702 54.3516H77.2994C88.1172 54.3516 93.5261 54.3516 96.8867 57.7122C100.247 61.0729 100.247 66.4818 100.247 77.2996C100.247 88.1174 100.247 93.5263 96.8867 96.887C93.5261 100.248 88.1172 100.248 77.2994 100.248H46.702C35.8841 100.248 30.4752 100.248 27.1146 96.887C23.7539 93.5263 23.7539 88.1174 23.7539 77.2996Z",
    fill: "#513117"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0009 84.9471C66.2255 84.9471 69.6503 81.5224 69.6503 77.2978C69.6503 73.0732 66.2255 69.6484 62.0009 69.6484C57.7763 69.6484 54.3516 73.0732 54.3516 77.2978C54.3516 81.5224 57.7763 84.9471 62.0009 84.9471Z",
    fill: "#513117"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9206 46.6994C41.9206 35.6097 50.9105 26.6198 62.0002 26.6198C71.3525 26.6198 79.2181 33.0163 81.4473 41.6774C81.8422 43.2116 83.406 44.1352 84.9402 43.7403C86.4745 43.3454 87.3981 41.7816 87.0032 40.2474C84.1375 29.1131 74.0336 20.8828 62.0002 20.8828C47.7421 20.8828 36.1836 32.4413 36.1836 46.6994V54.5576C37.8531 54.4329 39.7506 54.3826 41.9206 54.3624V46.6994Z",
    fill: "#513117"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.454 12.7687C102.818 11.8479 104.121 11.8479 104.484 12.7687L105.764 16.0133C105.874 16.2945 106.097 16.517 106.378 16.6279L109.623 17.9075C110.544 18.2707 110.544 19.5739 109.623 19.937L106.378 21.2167C106.097 21.3276 105.874 21.5501 105.764 21.8312L104.484 25.0758C104.121 25.9966 102.818 25.9966 102.454 25.0758L101.175 21.8312C101.064 21.5501 100.841 21.3276 100.56 21.2167L97.3156 19.937C96.3948 19.5739 96.3948 18.2707 97.3156 17.9075L100.56 16.6279C100.841 16.517 101.064 16.2945 101.175 16.0133L102.454 12.7687Z",
    fill: "#513117"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.3323 67.1976C10.5245 66.7102 11.2144 66.7102 11.4067 67.1976L12.0842 68.9154C12.1429 69.0642 12.2607 69.182 12.4095 69.2407L14.1272 69.9182C14.6147 70.1105 14.6147 70.8004 14.1272 70.9926L12.4095 71.6701C12.2607 71.7288 12.1429 71.8466 12.0842 71.9954L11.4067 73.7132C11.2144 74.2007 10.5245 74.2007 10.3323 73.7132L9.65479 71.9954C9.59609 71.8466 9.47828 71.7288 9.32945 71.6701L7.61171 70.9926C7.12422 70.8004 7.12422 70.1105 7.61171 69.9182L9.32945 69.2407C9.47828 69.182 9.59609 69.0642 9.65479 68.9154L10.3323 67.1976Z",
    fill: "#513117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6b688c477f34dcbba661adbe865bc8f6.svg";
export { ForwardRef as ReactComponent };